export default __webpack_public_path__ + "static/media/CdlA GC leader jersey.d2ab2332.png";